import { Component, OnInit } from '@angular/core';
import { filter, map } from 'rxjs';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { MatMenuModule } from '@angular/material/menu';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-title-bar',
  imports: [MatMenuModule, CommonModule, TranslateModule],
  templateUrl: './title-bar.component.html',
  standalone: true,
  styleUrl: './title-bar.component.css',
})
export class TitleBarComponent implements OnInit {
  title = 'Home';

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {
          let route = this.activatedRoute;
          while (route.firstChild) route = route.firstChild;
          return route;
        }),
        filter((route) => route.outlet === 'primary'),
        map((route) => route.snapshot.data['title']),
      )
      .subscribe((title) => {
        if (title) this.title = title;
      });
  }

  ngOnInit(): void {}
}
